module.exports = __webpack_public_path__ + "static/media/beatrice_elena_fotache.f8ac64ec.jpg";